import type { RatingOptions, RatingState, SeedLevel } from "./types.js";

/**
 * Defaults from docs/rating-engine.md §9. Every one of these is tunable at runtime;
 * changing any of them requires a full recompute to keep history consistent.
 */
export const DEFAULT_OPTIONS: RatingOptions = {
  tau: 0.5,
  epsilon: 1e-6,
  rdFloor: 30,
  rdCeiling: 350,
  rdInflateC: 8,
  gameWeight: 0.75,
  pointWeight: 0.25,
  pointStretch: 2.5,
  outcomeClampMin: 0.05,
  outcomeClampMax: 0.95,
  carryMaxReduction: 0.4,
  carryRange: 600,
  provisionalThreshold: 40,
  inactivityDays: 30,
};

/** Internal rating that maps to display 4.000. */
export const BASELINE_RATING = 1500;

/**
 * Self-assessment seeds. Everyone starts with near-maximum RD, so a wrong
 * self-assessment corrects itself inside roughly ten matches — the honest and the
 * optimistic converge to the same place, they just get there differently.
 */
export const SEEDS: Record<SeedLevel, RatingState> = {
  new: { r: 1200, rd: 350, vol: 0.06 },
  casual: { r: 1400, rd: 350, vol: 0.06 },
  club: { r: 1550, rd: 320, vol: 0.06 },
  competitive: { r: 1750, rd: 320, vol: 0.06 },
};
